import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { TraineePersonalInfo } from "../../Models/Trainee";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { GeneralMethods } from "../../Handlers/GeneralMethods";
import { Router } from "../../Handlers/Router";
import Profile from "../../../Component/Client/Profile";

export class EditClientInfoVM extends InterActive{
    private id:string =''
    private marketers:{label:string , value:string}[] = []
    private data:TraineePersonalInfo = { arabic_name:'' , english_name:'' , email:'' , dial_code:'' , mobile:'' , is_male:false , national_id:'', national_id_img:null , nationality :'' , birth_date:'' , address:'' , marketer_id:'' }

    public get Marketers():{label:string , value:string }[] { return this.marketers }
    public get Data():TraineePersonalInfo { return this.data }

    public set ArabicName(value:string){ this.data.arabic_name = GeneralMethods.removeNonArabic(value); this.update() }
    public set EnglishName(value:string){ this.data.english_name =GeneralMethods.removeNonEnglish(value); this.update() }
    public set Email(value:string){ this.data.email = value; this.update() }
    public set DialCode(value:string){ this.data.dial_code = value; this.update() }
    public set Mobile(value:string){ this.data.mobile = GeneralMethods.removeNonNumeric(value); this.update() }
    public set NationalId(value:string){ this.data.national_id = value; this.update() }
    public set NationalIdImg(value:File|null){ this.data.national_id_img = value; this.update() }
    public set Nationality(value:string){ this.data.nationality = value; this.update() }
    public set BirthDate(value:string){ this.data.birth_date = value; this.update() }
    public set Adress(value:string){ this.data.address = value; this.update() }
    public set MarketerId(value:string){ this.data.marketer_id = value; this.update() }
    public set IsMale(value:boolean){ this.data.is_male = value; this.update() }

    constructor(id:string ){
        super()
        this.id = id
    }

    public loadData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.traineePersonalInfo(this.id)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data = response.data.data.data
                                this.marketers = response.data.data.marketers
                                this.update()
                            }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }
        )
    }

    public send(){
        if(this.validate()){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.EditTraineeInfo(this.getFormData())
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                Notify({type:'success' , title:'عملية ناجحة' ,body:'تم تعديل البيانات بنجاح'})
                                Router.OpenNormalPage(<Profile id={this.id}/>)
                            }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }
        )}
    }

    private validate(){
        if(this.data.arabic_name.length == 0){ Notify({type:'danger' , title:'خطأ' , body:'برجاء ادخال الاسم باللغة العربية'}) ; return false }
        if(this.data.english_name.length == 0){ Notify({type:'danger' , title:'خطأ' , body:'برجاء ادخال الاسم باللغة الانجليزية'}) ; return false }
        if(this.data.email){
            if(this.data.email.length > 0){
                if(!GeneralMethods.isValidEmail(this.data.email)){ Notify({type:'danger' , title:'خطأ' , body:'برجاء ادخال ايميل صالح'}) ; return false }
            }
        }
        if(this.data.mobile.length == 0){ Notify({type:'danger' , title:'خطأ' , body:'برجاء ادخال رقم الموبايل'}) ; return false }
        if(this.data.nationality.length == 0){ Notify({type:'danger' , title:'خطأ' , body:'برجاء ادخال الجنسية'}) ; return false }
        if(this.data.address.length == 0){ Notify({type:'danger' , title:'خطأ' , body:'برجاء ادخال العنوان'}) ; return false }

        return true;        
    }

    private getFormData(){
        
        const form = new FormData()
        form.append('id', this.id)
        form.append('arabic_name',this.data.arabic_name)
        form.append('english_name',this.data.english_name)
        if(this.data.email)form.append('email',this.data.email)
        form.append('dial_code',this.data.dial_code)
        form.append('mobile',this.data.mobile)
        if(this.data.national_id)form.append('national_id',this.data.national_id)
        form.append('nationality',this.data.nationality)
        if(this.data.birth_date)form.append('birth_date',this.data.birth_date)
        form.append('address',this.data.address)
        form.append('marketer_id',this.data.marketer_id)
        form.append('is_male',this.data.is_male?'1':'0')
        if(this.data.national_id_img)form.append( 'img' , this.data.national_id_img)

        return form

    }
}